module.exports = __webpack_public_path__ + "static/media/menu_pacientes.38c37fa6.png";